export const isDefaultConfig = (config) => {
    return config.createPaymentURL !== undefined;
};
//# sourceMappingURL=types.js.map